export default function EmptyState({
  title,
  message,
  actionLabel,
  onAction,
  icon: Icon = null,
}) {
  return (
    <div className="ef-empty-state card p-6 text-center">
      {Icon ? (
        <div className="ef-empty-state__icon mx-auto mb-3">
          <Icon className="w-8 h-8" aria-hidden />
        </div>
      ) : null}
      <h3 className="font-bold text-[var(--d28d-text)] text-base">{title}</h3>
      {message ? <p className="text-sm d28d-text-muted mt-2 max-w-md mx-auto">{message}</p> : null}
      {actionLabel && onAction ? (
        <button type="button" className="btn-primary mt-4 text-sm" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
